/**
 * LO QUE LEE UN AGENTE Y SU ESTADO DE GIT (INSTRUCCIONES-FUENTE-UNICA-T1 paso 3, Ares #37463; GO #37430).
 *
 * GET /api/v1/Instructions/lectura (nexo-api 651) devuelve la lista unica v_lectura_agente: agent_prompts (lo que leen
 * los agentes por MCP) y n8n_instructions (lo que muestra #/instructions), cada fila con estado_git calculado en la base
 * con la regla de v_instrucciones_correlacion: compara VERSIONES (version_normalizada de la base contra la del documento
 * registrado en Git), NO textos ni hashes. coincide = misma version; difiere = hay documento con otra version; sin fuente =
 * no hay documento registrado. Y una INS se lee como RESUMEN (texto_completo false): el agente no recibe el documento.
 * Las etiquetas dicen eso y nada mas (Q #37538). El panel no compara nada: muestra el estado de la API (P #37507).
 *
 * Sin DOM: lo prueba scripts/check-lectura-del-agente.mjs.
 */

const texto = (v) => (v == null ? '' : String(v));
const campo = (o, ...k) => { for (const c of k) if (o?.[c] !== undefined && o[c] !== null) return o[c]; return undefined; };

export const ESTADOS = {
  coincide: { clave: 'coincide', etiqueta: 'Git: misma versión', color: '#3fb950', ayuda: 'La versión registrada en la base es la misma del documento en Git.' },
  difiere: { clave: 'difiere', etiqueta: 'Git: otra versión', color: '#d29922', ayuda: 'Hay documento en Git, pero con otra versión que la registrada en la base.' },
  sin_fuente: { clave: 'sin_fuente', etiqueta: 'Sin fuente', color: '#8b949e', ayuda: 'Esta instrucción aún no tiene su documento de Git registrado.' }
};

/** "coincide" | "difiere" | "sin fuente" (con espacio, como lo manda la API) -> una de las tres claves. */
export function estadoDe(fila) {
  const e = texto(campo(fila, 'estado_git', 'estadoGit')).trim().toLowerCase().replace(/[\s_]+/g, '_');
  if (e === 'coincide') return ESTADOS.coincide;
  if (e === 'difiere') return ESTADOS.difiere;
  return ESTADOS.sin_fuente;
}

/** Una fila de la API en la forma del panel (tolera snake_case y camelCase). */
function fila(f) {
  return {
    codigo: texto(campo(f, 'codigo', 'Codigo')),
    tipo: texto(campo(f, 'tipo', 'Tipo')),
    version: texto(campo(f, 'version', 'Version')),
    almacen: texto(campo(f, 'almacen', 'Almacen')),
    vigente: campo(f, 'vigente', 'Vigente') === true,
    // false = el agente recibe un resumen (la descripcion), no el documento.
    textoCompleto: campo(f, 'texto_completo', 'textoCompleto') === true,
    versionGit: texto(campo(f, 'version_git', 'versionGit')),
    rutaGit: texto(campo(f, 'ruta_git', 'rutaGit')),
    commitGit: texto(campo(f, 'commit_git', 'commitGit')),
    estado: estadoDe(f)
  };
}

/**
 * @returns {{ok: true, filas: Array} | {ok: false, motivo: string, frase: string}}
 * 404 de la ruta = la lectura aun no esta publicada en esta API (se dice asi, no como error).
 */
export function leerLectura(res) {
  if (!res?.ok) {
    if (res?.code === 404) return { ok: false, motivo: 'NO_PUBLICADA', frase: 'La lectura de lo que lee un agente aún no está publicada en esta API.' };
    if (res?.code === 403) return { ok: false, motivo: 'PERMISO', frase: 'Tu usuario no puede ver la lista de lo que lee un agente.' };
    return { ok: false, motivo: 'RED', frase: 'No pudimos traer la lista de lo que lee un agente: ' + texto(res?.error || 'sin respuesta') };
  }
  const data = res.data?.data ?? res.data;
  if (!Array.isArray(data)) return { ok: false, motivo: 'FORMA', frase: 'La API respondió sin la lista esperada.' };
  return { ok: true, filas: data.map(fila).filter((f) => f.codigo) };
}

/** Cuantas coinciden, difieren y no tienen fuente: en total y por almacen. */
export function resumen(filas) {
  const vacio = () => ({ total: 0, coincide: 0, difiere: 0, sin_fuente: 0 });
  const total = vacio();
  const porAlmacen = {};
  for (const f of filas || []) {
    const a = (porAlmacen[f.almacen] ||= vacio());
    for (const r of [total, a]) { r.total++; r[f.estado.clave]++; }
  }
  return { total, porAlmacen };
}

/** El estado por codigo, solo de un almacen (la lista de #/instructions es n8n_instructions). */
export function estadosPorCodigo(filas, almacen) {
  const m = new Map();
  for (const f of filas || []) if (!almacen || f.almacen === almacen) m.set(f.codigo, f);
  return m;
}
